<template>
<div class="StakePage">

<b-modal ref="netmodal" hide-footer hide-header>
      <div class="d-block text-center">
        <h3 class="modalText">Please connect to <br><br>Ethereum Main Network!</h3>
      </div>
</b-modal>

    <div class="centerDiv">
                <b-container>
                    <b-row>
                        <b-col cols="12">        
                            <br><br><br><br>
                            <div v-if="!walletAddress">
                                <br><br><br><br>
                                <button @click="LoadEthWallet()" class="css-t6n5l8" >Connect To Wallet!</button>
                                <br><br><br><br><br><br><br><br>
                                <br><br><br><br>
                            </div>
                            
                            <div v-if="walletAddress">
                                <b-container>
                                    <b-row>
                                        <b-col cols="12">
                                            
                                            <main class="css-1aldbke">
                                            <div class="css-4m1mkq">
                                                <div class="css-1vr28rc">
                                                <div class="css-1k1pdls">
                                                    <div class="css-1xbci16">
                                                    <h2 class="css-19p8l23">Cosmic Staking</h2>
                                                    <br>
                                                    <h2 class="css-vurnku">Total Staked</h2>
                                                    <b-progress :value="value" :max="max" show-progress animated></b-progress>
                                                    <h2 class="css-vurnku">{{value}} / {{max}}   |   {{((value / max) * 100).toFixed(2)}} %</h2>
                                                    <div class="css-1hxnl64">
                                                        <div class="css-1sjtv36">
                                                        <div class="css-1ude38q">
                                                            <div class="css-zkfaav">
                                                            <div class="css-vurnku">
                                                            {{totalrewardsinwallet}}
                                                            </div></div>
                                                            <div class="css-vurnku">
                                                            Wallet Balance
                                                            </div>
                                                        </div>

                                                        <div class="css-8mokm4">
                                                            {{howManyNftsAvailableWithdraw}} Cosmic Ducks Staked!
                                                        </div>
                                                        <div class="css-vurnku">
                                                            <b-icon v-if="loadingTransactionToken" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
                                                        </div>
                                                        <div class="css-8mokm4">
                                                            Wallet Address : {{walletAddress.substring(0,6)}}<br>
                                                            Wallet Balance : {{walletBalance.substring(0,6)}}
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    
                                                </div>
                                                </div>
                                            </div>
                                                
                                            
                                            </main>                                            
                                        </b-col>
                                    </b-row>
                                </b-container>

                                <b-container>
                                    <!-- <b-row v-if="!isApproved">
                                        <b-col cols="12">
                                            <button v-if="!loadingTransaction" class="css-1i7awws" @click="Approve()">Approve Staking!</button>
                                            <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
                                        </b-col>
                                    </b-row> -->


                                    <b-row v-if="isApproved && !isMobile()">
                                        <!-- <b-col cols="6">
                                            <b-card header="Select Ducks To Stake" class="scrollCard" v-if="howManyNftsAvailable > 0">
                                                <div v-if="!loadingTransaction">
                                                    <br><br>
                                                    <div v-for="(id) in nftsById" :key="id">
                                                        <h2 v-if="id <= 1000">Genesis Duck #{{id}}</h2>
                                                        <h2 v-if="id >= 1001">Cosmic Duck #{{id}}</h2>
                                                        
                                                        <button v-if="id <= 1000" class="nftButton" @click="addNft(id)"><img class="imageOfDuck" :src="ipfsLink2 + id + '.gif'" alt=""></button>
                                                        <button v-if="id >= 1001" class="nftButton" @click="addNft(id)"><img class="imageOfDuck" :src="ipfsLink + id + '.png'" alt=""></button>

                                                        <br><br>
                                                    </div>
                                                </div>
                                                <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
                                            </b-card>            
                                            <br><br>
                                            <h2 v-if="selectedNFTsToStake.length > 0 && !loadingTransaction" class="css-vurnku">You have selected {{selectedNFTsToStake}} to stake!</h2>
                                            <br><br>
                                            <button v-if="selectedNFTsToStake.length > 0 && !loadingTransaction" @click="StakeAll()" class="css-1i7awws">Stake Now!</button>                                  
                                        </b-col> -->

                                        <b-col cols="12">
                                        <button v-if="howManyNftsAvailableWithdraw > 0 && !loadingTransaction" @click="WithdrawAll()" class="css-1i7awws">Withdraw All!</button>                                             
                                        </b-col>
                                    </b-row>



                                    <b-row v-if="isApproved && isMobile()">
                                        <b-col cols="12">
<!--                                             <b-card header="Stake Ducks" class="scrollCard" v-if="howManyNftsAvailable > 0">
                                                <div v-if="!loadingTransaction">
                                                    <br><br>
                                                    <div v-for="(id) in nftsById" :key="id">
                                                        <h2 v-if="id <= 1000">Genesis Duck #{{id}}</h2>
                                                        <h2 v-if="id >= 1001">Cosmic Duck #{{id}}</h2>

                                                        <button v-if="id <= 1000" class="nftButton" @click="addNft(id)"><img class="imageOfDuck" :src="ipfsLink2 + id + '.gif'" alt=""></button>
                                                        <button v-if="id >= 1001" class="nftButton" @click="addNft(id)"><img class="imageOfDuck" :src="ipfsLink + id + '.png'" alt=""></button>

                                                        <br><br>
                                                    </div>
                                                </div>
                                                <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
                                            </b-card>     
                                            <br><br>
                                            <h2 v-if="selectedNFTsToStake.length > 0 && !loadingTransaction" class="css-vurnku">You have selected <br>{{selectedNFTsToStake}} <br>to stake!</h2>
                                            <br><br>
                                            <button v-if="selectedNFTsToStake.length > 0 && !loadingTransaction" @click="StakeAll()" class="css-1i7awws">Stake Now!</button> -->
                                        
                                        <br><br><br><br>

                                            <button v-if="howManyNftsAvailableWithdraw > 0 && !loadingTransaction" @click="WithdrawAll()" class="css-1i7awws">Withdraw All!</button> 
                                        </b-col>
                                    </b-row>





                                </b-container>                                
                            </div>
                        <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
            <Footer/>
        </div>      

</template>

<script>
import Web3 from 'web3';
import contractInfo from '../assets/contracts/clabs.json'
import NavBar from './Navigation/NavBar.vue'
import Footer from './Navigation/Footer.vue'

export default {
    name: "Stake",
    components:
    {
        NavBar,
        Footer
    },
    data: function () {
            return {
                walletConnect: '',

                walletAddress: '',
                walletBalance: '',

                howManyNftsAvailable: null,
                nftsById: [],

                nftsStakedById: [],
                howManyNftsAvailableWithdraw: null,

                selectedNFTsToStake: [],
                selectedNFTsToWithdraw: [],

                totalrewardsinwallet: '',
                totalrewardsearned: '0',

                isApproved: null,

                value: null,
                max: 9000,

                web3: '',

                cosmiclabsContract: '',
                contractAbi: contractInfo.abi,
                contractAddress: contractInfo.contractAddress,
                loadingTransaction: false,
                loadingTransactionToken: false,
                
                soldOut: false,

                ipfsLink: 'https://cosmiclabs.mypinata.cloud/ipfs/QmVHZ3AgKQsz6m62jjuf56uHuaZYAShXW9rUMs8rP8pRrA/',
                ipfsLink2: 'https://cosmiclabs.mypinata.cloud/ipfs/QmctzpRxLg9Tk5nTgsczAy6W4reeN85n3BDohT27bEdRib/'

            }
    },
    mounted()
    {
        this.LoadEthWallet();
    },
    methods:
    {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        Approve()
        {
            this.loadingTransaction = true;
            this.web3.eth.personal.sign("By interacting with the staking functions, you are granting permission to Cosmic-labs.io to withdraw your Cosmic NFT and automate Cosmic Utility Token transactions for you until you decide to withdraw from staking. You also acknowledge that the Cosmic Utility Token does not carry monetary value and is designed to be used within the Cosmic Labs & Cosmic Gaming Ecosystem", this.walletAddress)
            .then(res=>{                      
                this.cosmiclabsContract.methods.setApprovalForAll(this.contractAddress.toString(), true).send({from: this.walletAddress})
                .on('confirmation', function(confirmationNumber, receipt)
                {
                        
                })     
                .then(res=>{
                    this.LoadNFTs();
                    this.loadingTransaction = false;
                })
                .catch(err=>{
                    this.loadingTransaction = false;
                })
            })
            .catch(err=>{
                    this.loadingTransaction = false;
            })
        },
        addNft(id)
        {

            var exists = false;
            var existingId;


            for(var i=0; i<this.selectedNFTsToStake.length;i++)
            {
                if(this.selectedNFTsToStake[i] == id)
                {
                    exists = true;
                    existingId = i;
                }
            }

            if(!exists)
            {
                this.selectedNFTsToStake.push(id);
            }
            else
            {
                this.selectedNFTsToStake.splice(existingId,1);
            }
        },
        addNftWithdraw(id)
        {

            var exists = false;
            var existingId;


            for(var i=0; i<this.selectedNFTsToWithdraw.length;i++)
            {
                if(this.selectedNFTsToWithdraw[i] == id)
                {
                    exists = true;
                    existingId = i;
                }
            }

            if(!exists)
            {
                this.selectedNFTsToWithdraw.push(id);
            }
            else
            {
                this.selectedNFTsToWithdraw.splice(existingId,1);
            }
        },
        /* StakeNFTByID(id)
        {
            this.loadingTransaction = true;
            var tempArry = [];
            tempArry.push(id);
            this.cosmiclabsContract.methods.depositStake(tempArry).send({from: this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt)
            {
                    
            })
            .then(res=>{
                alert("You've Staked Duck #" + id);
                this.loadingTransaction = false
                this.LoadNFTs();
            })
            .catch(err=>{
                    this.loadingTransaction = false;
                })
        },
        StakeAll()
        {
            if(this.selectedNFTsToStake.length > 0)
            {
                this.loadingTransaction = true;
                this.cosmiclabsContract.methods.depositStake(this.selectedNFTsToStake).send({from: this.walletAddress})
                .on('confirmation', function(confirmationNumber, receipt)
                {
                        
                })
                .then(res=>{
                    alert("You've Staked them!");
                    this.LoadNFTs();
                    this.loadingTransaction = false;
                    this.selectedNFTsToStake = [];
                })
                .catch(err=>{
                        this.loadingTransaction = false;
                })
            }
            else
            {
                alert("Please Select ducks to stake!")
            }
            
        }, */
        WithdrawNFTByID(id)
        {
            var tempArry = [];
            tempArry.push(id);
            this.loadingTransaction = true;

            this.cosmiclabsContract.methods.withdrawStake(tempArry).send({from: this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt)
            {
                    
            })
            .then(res=>{
                alert("You've Withdrawn Duck #" + id);
                this.LoadNFTs();
                this.loadingTransaction = false;
            })
            .catch(err=>{
                    this.loadingTransaction = false;
            })
        },
        WithdrawAll()
        {

            this.loadingTransaction = true;
            this.cosmiclabsContract.methods.withdrawStake(this.nftsStakedById).send({from: this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt)
            {
                    
            })
            .then(res=>{
                alert("You've withdrawn all!");
                this.LoadNFTs();
                this.loadingTransaction = false;
            })
            .catch(err=>{
                    this.loadingTransaction = false;
            })


            
        },
        withdrawTokens()
        {
            this.loadingTransactionToken = true;
            this.cosmiclabsContract.methods.claimRewards().send({from: this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt)
            {
                    
            })
            .then(res=>{
                alert("You've Withdrawn All your tokens!");
                this.LoadNFTs();
                this.loadingTransactionToken = false;
            })  
            .catch(err=>{
                    this.loadingTransactionToken = false;
            })          
        },        
        LoadNFTs: function()
        {  
            
            this.cosmiclabsContract = new this.web3.eth.Contract(this.contractAbi, this.contractAddress);
            
            this.cosmiclabsContract.methods.walletOfOwner(this.contractAddress).call({from: this.walletAddress})
            .then(res=>{
                this.value = res.length;
            })


            this.cosmiclabsContract.methods.balanceOf(this.walletAddress).call({from: this.walletAddress})
            .then(res=>{
                this.howManyNftsAvailable = res;
            })

            this.cosmiclabsContract.methods.walletOfOwner(this.walletAddress).call({from: this.walletAddress})
            .then(res=>{
                this.nftsById = res;            
            })

            this.nftsStakedById = [];
            this.cosmiclabsContract.methods.returnStakedTokens().call({from: this.walletAddress})
            .then(res=>{
                for(var i=0; i <res.length; i++)
                {
                    if(Number(res[i]) !== 0)
                    {
                        this.nftsStakedById.push(res[i]);                                
                    }     
                }

                this.howManyNftsAvailableWithdraw = res.length;
            })
            
            this.cosmiclabsContract.methods.totalTokensInWallet().call({from: this.walletAddress})
            .then(res=>{
                this.totalrewardsinwallet = this.web3.utils.fromWei(res, 'ether');
            })


            this.cosmiclabsContract.methods.viewRewards().call({from: this.walletAddress})
            .then(res=>{
                this.totalrewardsearned = res;
            })


            this.cosmiclabsContract.methods.isApprovedForAll(this.walletAddress, this.contractAddress).call({from: this.walletAddress})
            .then(res=>{
                this.isApproved = res;
            })


          
        },
        LoadEthWallet: function(){
            
            if (typeof window.ethereum !== 'undefined') 
                {
                    ethereum.enable();
                    this.web3 = new Web3(this.walletConnect || window.ethereum || new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/1xVMLkEDl6htSmYN7YeFXGvIe07") || Web3.givenProvider);
                    this.web3.eth.net.getNetworkType()
                    .then(network=>{
                        if(network == "main")
                        {
                            this.web3.eth.requestAccounts()
                            .then(acc=>{
                                this.walletAddress = acc[0];
                                this.web3.eth.getBalance(this.walletAddress)
                                .then(balance=>{
                                    this.walletBalance = this.web3.utils.fromWei(balance, "ether");     
                                    this.LoadNFTs();
                                });
                            })
                            .catch(err=>{
                                console.log(err);
                            })            
                        }
                        else{
                            this.$refs['netmodal'].show();
                        }          
                    })
                }

            
        },       
    },
    watch: {
          walletAddress: function(val) {
            window.ethereum.on("accountsChanged", accounts => {
              if (accounts.length > 0)
              {
                this.walletAddress = accounts[0];
                this.web3.eth.getBalance(this.walletAddress)
                .then(balance=>{
                  this.walletBalance = this.web3.utils.fromWei(balance, "ether");     
                });
                this.LoadNFTs();
              } 
              else 
              {
                this.walletAddress = '';
                this.walletBalance = '';
              }
            })
          },
          walletBalance: function(val)
          {
            window.ethereum.on("balanceChanged", balance => 
            {
              this.walletBalance = balance;
              this.LoadNFTs();
            })
            
          },
    },      
}
</script>

<style scoped>
.StakePage
{
  background: #000 repeat !important;
}

.imageOfDuck
{
    width: 50%;
}
.scrollCard
{
    max-height: 50vh;
    overflow-y: auto;
}
.nftButton
{
    border: none !important;
    background: transparent !important;
}
.centerDiv
{
    margin: auto;
}
.css-1aldbke {
    box-sizing: border-box;
    margin: 0;
    min-width: 0;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
}
.css-4m1mkq {
    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
    width: 100%;
}
.css-1vr28rc {
    box-sizing: border-box;
    margin: 0;
    min-width: 0;
    width: 100%;
    max-width: container;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    padding-bottom: 8rem;
    padding-left: 0rem;
    padding-right: 0rem;
}

@media screen and (min-width: 48em){
.css-1k1pdls {
    padding-left: 1
rem
;
    padding-right: 1
rem
;
    max-width: 75
rem
;
}
}

.css-1k1pdls {
    box-sizing: border-box;
    margin: 0;
    min-width: 0;
    width: 100%;
    max-width: container;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    max-width: 35.5rem;
}

.css-1xbci16 {
    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
    -webkit-box-pack: justify;
    justify-content: space-between;
    gap: 1rem;
    flex-direction: column;
    display: flex;
}

.css-19p8l23 {
    box-sizing: border-box;
    margin: 3.125rem 0px 0px;
    min-width: 0px;
    line-height: 1.2;
    font-weight: 500;
    font-size: 3rem;
    color: white;
}

.css-1hxnl64 {
    box-sizing: border-box;
    margin: 2rem 0px;
    padding: 1.5rem;
    border-radius: 0px;
    border: 1px solid rgb(224, 224, 224);
    display: inline-block;
    min-width: 18.75rem;
}

.css-1sjtv36 {
    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
    display: grid;
    gap: 1rem;
}

.css-1ude38q {
    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
    -webkit-box-align: center;
    align-items: center;
    font-size: 1.25rem;
    font-weight: 500;
    color: white;
    display: flex;
}

.css-zkfaav {
    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
    -webkit-box-align: center;
    align-items: center;
    display: flex;
}
.css-vurnku {
    box-sizing: border-box;
    margin: 0;
    min-width: 0;
    color: white !important;
}
.css-s9e42g {
    box-sizing: border-box;
    margin: 0px 0.5rem;
    min-width: 0px;
    max-width: 100%;
    height: auto;
    max-height: 2.1875rem;
    position: relative;
    top: -2px;
    width: 1.0625rem;
}
.css-8mokm4 {
    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
    font-weight: 500;
    color: white !important;
}
.css-t6n5l8 {
    box-sizing: border-box;
    margin: 0;
    min-width: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    display: inline-block;
    text-align: center;
    line-height: inherit;
    -webkit-text-decoration: none;
    text-decoration: none;
    font-size: inherit;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    color: white;
    border: 0;
    border-radius: 4px;
    cursor: pointer;
    background: linear-gradient(90deg, #c400ff 0%, #78009f 100%);
    font-size: 0.875rem;
    text-align: center;
    font-weight: 500;
    border-radius: 0px;
    padding-left: 2.78em;
    padding-right: 2.78em;
    padding-top: 0.61em;
    padding-bottom: 0.61em;
    -webkit-transition: 0.3s ease-in-out;
    transition: 0.3s ease-in-out;
}
.css-1dpti2z {
    box-sizing: border-box;
    margin: 0px 0px 1rem;
    min-width: 0px;
    color: white !important;
}
.css-zm05v7 {
    box-sizing: border-box;
    margin: 0px 0px 3.125rem;
    min-width: 0px;
    gap: 1rem;
    display: flex;
}
.css-1i7awws {
    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
    appearance: none;
    display: inline-block;
    line-height: inherit;
    text-decoration: none;
    cursor: pointer;
    background-image: initial;
    background-position: initial;
    background-size: initial;
    background-repeat: initial;
    background-attachment: initial;
    background-origin: initial;
    background-clip: initial;
    color: black;
    font-size: 1rem;
    text-align: center;
    font-weight: 500;
    border-radius: 0px;
    padding: 1.25em 1.5em;
    transition: all 0.3s ease-in-out 0s;
    border: 1px solid #C400FF;
}

.css-748hg8 {
    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
    appearance: none;
    display: inline-block;
    line-height: inherit;
    text-decoration: none;
    cursor: pointer;
    background-image: initial;
    background-position: initial;
    background-size: initial;
    background-repeat: initial;
    background-attachment: initial;
    background-origin: initial;
    background-clip: initial;
    color: black !important;
    font-size: 1rem;
    text-align: center;
    font-weight: 500;
    border-radius: 0px;
    padding: 1.25em 1.5em;
    transition: all 0.3s ease-in-out 0s;
    border: 1px solid #C400FF;
}
</style>


// WEBPACK FOOTER //
// src/components/oldUnstake.vue